import { Backdrop, CircularProgress } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

interface Props {
    message?: string;
}

const CustomBackdrop = ({ message }: Props) => (
    <Backdrop
        open={true}
        sx={{
            zIndex: 100,
        }}
    >
        {message && (
            <Box
                sx={{
                    bgcolor: 'white',
                    p: 2,
                    borderRadius: 1,
                    display: 'grid',
                    justifyContent: 'center',
                    justifyItems: 'center',
                    gap: 3,
                }}
            >
                <Typography>{message}</Typography>

                <CircularProgress />
            </Box>
        )}

        {!message && <CircularProgress />}
    </Backdrop>
);

export default CustomBackdrop;
